import React, { useState, useRef, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { bool, string, array, func } from 'prop-types';
import { FormGroup, Input, Label } from 'reactstrap';
import CustomControl from '../CustomControl/CustomControl';

const NOTIFICATION_GROUPS = [
  { id: 'finances', title: 'Финансы', ids: [7, 8, 9] },
  { id: 'products', title: 'Продукты', ids: [3, 4, 5, 11, 13, 17, 21, 14] },
  { id: 'tickets', title: 'Тикеты', ids: [1, 2] },
];

const defaultNotificationsTime = '21:00';

const TelegramActivationBlock = ({
  activationCode,
  botLink,
  isTelegramConnected,
  notifications,
  onChange,
}) => {
  const [copiedField, setCopiedField] = useState(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const handleCopy = (text, field) => {
    if (text) {
      navigator.clipboard.writeText(text);
      setCopiedField(field);

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        setCopiedField(null);
      }, 3000);
    }
  };

  const checkTimeString = (e) => {
    const { target } = e;
    const isValid = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(target.value);

    if (!isValid) {
      target.value = defaultNotificationsTime;
    }
  };

  const findNotificationIndex = (notificationId) =>
    notifications.findIndex((n) => n.id === notificationId);

  const getTimeParam = (notification) => {
    const { params } = notification;
    if (!params || Array.isArray(params)) return null;
    return params.time || null;
  };

  return (
    <div className="profile-telegram-activation">
      <div className="profile-telegram-activation-header">
        <h6 className="profile-edit-form-title">
          <FormattedMessage id="profile.telegram.title" defaultMessage="Telegram" />
        </h6>

        {isTelegramConnected && (
          <span className="profile-telegram-connected-badge">
            <FormattedMessage id="profile.telegram.connected" defaultMessage="Привязан" />
          </span>
        )}
      </div>

      {!isTelegramConnected && (
        <>
          <p className="profile-telegram-activation-text">
            <FormattedMessage
              id="profile.telegram.activation.description"
              defaultMessage="Send the activation code to our telegram bot to link your account."
            />
          </p>

          {botLink && (
            <FormGroup className="form-group-upper-label">
              <Label htmlFor="telegram">
                <FormattedMessage
                  id="profile.telegram.activation.bot-link"
                  defaultMessage="Telegram bot"
                />
              </Label>
              <div className="profile-telegram-activation-input">
                <Input id="telegram" type="text" name="telegram" value={botLink} readOnly={true} />
                <button
                  className="profile-telegram-activation-copy"
                  onClick={() => handleCopy(botLink, 'botLink')}
                >
                  {copiedField === 'botLink' ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                    >
                      <path
                        d="M12.6049 0.278376C12.7964 -0.00882936 13.1844 -0.0864341 13.4716 0.105036C13.7588 0.296507 13.8364 0.68453 13.645 0.971735L6.14497 12.2217C6.04116 12.3775 5.87302 12.4783 5.6868 12.4968C5.50047 12.5153 5.31546 12.4494 5.18306 12.3169L0.183058 7.31695C-0.0610194 7.07287 -0.0610194 6.67724 0.183058 6.43316C0.427136 6.18908 0.82277 6.18908 1.06685 6.43316L5.5273 10.8936L12.6049 0.278376Z"
                        fill="#161616"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M15.984 11.65c.017.975-.767 1.8-1.725 1.842h-.4V9.758c0-.508-.192-.991-.542-1.35l-2.45-2.55a1.94 1.94 0 0 0-1.4-.6H7.401v-.383a1.78 1.78 0 0 1 1.783-1.75h2.867v1.542a2.523 2.523 0 0 0 2.508 2.516h1.425zm-3.375 3.375c.008 1-.767 1.808-1.733 1.85h-5.1a1.75 1.75 0 0 1-1.259-.558 1.75 1.75 0 0 1-.5-1.292V8.258a1.797 1.797 0 0 1 1.792-1.75h2.858v1.55c0 1.375 1.125 2.5 2.509 2.509h1.433zm4.092-10-2.45-2.55a1.96 1.96 0 0 0-1.4-.6H9.184C7.55 1.875 6.192 3.2 6.15 4.858v.4h-.342c-1.642 0-3 1.334-3.042 2.984v6.766a3.04 3.04 0 0 0 .842 2.175 3.02 3.02 0 0 0 2.125.942H10.9a3.077 3.077 0 0 0 2.958-3.1v-.283h.417c1.658-.067 2.983-1.459 2.958-3.1V6.375c0-.525-.192-1.008-.533-1.35"
                        clipRule="evenodd"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </FormGroup>
          )}

          {activationCode && (
            <FormGroup className="form-group-upper-label">
              <Label htmlFor="activation-code">
                <FormattedMessage
                  id="profile.telegram.activation.code-label"
                  defaultMessage="Activation code"
                />
              </Label>
              <div className="profile-telegram-activation-input">
                <Input
                  id="activation-code"
                  type="text"
                  name="activation-code"
                  value={activationCode}
                  readOnly={true}
                />
                <button
                  className="profile-telegram-activation-copy"
                  onClick={() => handleCopy(activationCode, 'activationCode')}
                >
                  {copiedField === 'activationCode' ? (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="13"
                      viewBox="0 0 14 13"
                      fill="none"
                    >
                      <path
                        d="M12.6049 0.278376C12.7964 -0.00882936 13.1844 -0.0864341 13.4716 0.105036C13.7588 0.296507 13.8364 0.68453 13.645 0.971735L6.14497 12.2217C6.04116 12.3775 5.87302 12.4783 5.6868 12.4968C5.50047 12.5153 5.31546 12.4494 5.18306 12.3169L0.183058 7.31695C-0.0610194 7.07287 -0.0610194 6.67724 0.183058 6.43316C0.427136 6.18908 0.82277 6.18908 1.06685 6.43316L5.5273 10.8936L12.6049 0.278376Z"
                        fill="#161616"
                      />
                    </svg>
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M15.984 11.65c.017.975-.767 1.8-1.725 1.842h-.4V9.758c0-.508-.192-.991-.542-1.35l-2.45-2.55a1.94 1.94 0 0 0-1.4-.6H7.401v-.383a1.78 1.78 0 0 1 1.783-1.75h2.867v1.542a2.523 2.523 0 0 0 2.508 2.516h1.425zm-3.375 3.375c.008 1-.767 1.808-1.733 1.85h-5.1a1.75 1.75 0 0 1-1.259-.558 1.75 1.75 0 0 1-.5-1.292V8.258a1.797 1.797 0 0 1 1.792-1.75h2.858v1.55c0 1.375 1.125 2.5 2.509 2.509h1.433zm4.092-10-2.45-2.55a1.96 1.96 0 0 0-1.4-.6H9.184C7.55 1.875 6.192 3.2 6.15 4.858v.4h-.342c-1.642 0-3 1.334-3.042 2.984v6.766a3.04 3.04 0 0 0 .842 2.175 3.02 3.02 0 0 0 2.125.942H10.9a3.077 3.077 0 0 0 2.958-3.1v-.283h.417c1.658-.067 2.983-1.459 2.958-3.1V6.375c0-.525-.192-1.008-.533-1.35"
                        clipRule="evenodd"
                      />
                    </svg>
                  )}
                </button>
              </div>
            </FormGroup>
          )}

          <p className="profile-telegram-activation-text-info">
            <FormattedMessage
              id="profile.telegram.activation.info"
              defaultMessage="Activation code"
            />
          </p>
        </>
      )}

      {notifications.length > 0 &&
        NOTIFICATION_GROUPS.map((group) => {
          const groupItems = group.ids
            .map((notificationId) => ({
              index: findNotificationIndex(notificationId),
              notification: notifications.find((n) => n.id === notificationId),
            }))
            .filter(({ index, notification }) => index !== -1 && notification);

          if (!groupItems.length) return null;

          return (
            <div className="profile-telegram-notifications-group" key={group.id}>
              <p className="profile-telegram-activation-text">{group.title}</p>

              {groupItems.map(({ index, notification }) => {
                const timeParam = getTimeParam(notification);
                const isChecked = notification.transport.telegram.checked;

                return (
                  <React.Fragment key={notification.id}>
                    <div className="profile-telegram-notification-row">
                      <span className="profile-telegram-notification-row-title">
                        {notification.title}
                      </span>

                      <CustomControl
                        type="checkbox"
                        id={`telegram_notification_${notification.id}`}
                        name={`${index}_transport_telegram`}
                        onChange={onChange}
                        checked={isChecked}
                        disabled={notification.transport.telegram.disabled}
                        className="custom-checkbox-switch"
                      />
                    </div>

                    {timeParam && isChecked && (
                      <div className="profile-telegram-notification-time">
                        <Input
                          type="time"
                          name={`${index}_params_time`}
                          value={timeParam.value}
                          onChange={onChange}
                          onBlur={checkTimeString}
                          className="profile-telegram-notification-time-input"
                        />
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
            </div>
          );
        })}
    </div>
  );
};

TelegramActivationBlock.propTypes = {
  activationCode: string,
  botLink: string,
  isTelegramConnected: bool,
  notifications: array,
  onChange: func,
};

TelegramActivationBlock.defaultProps = {
  activationCode: '',
  botLink: '',
  isTelegramConnected: false,
  notifications: [],
  onChange() {},
};

export default TelegramActivationBlock;
